/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M3.25 9.25A.75.75 0 0 1 4 8.5h8.5a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75ZM4 12.25a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5H4Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.75 0C1.679 0 0 1.679 0 3.75v13c0 2.0711 1.679 3.75 3.75 3.75h7.5825c1.1483 2.0863 3.3678 3.5 5.9175 3.5 3.7279 0 6.75-3.0221 6.75-6.75 0-1.6075-.5619-3.0837-1.5-4.243V3.75C22.5 1.679 20.8211 0 18.75 0h-15ZM21 11.6367V6.25H1.5v10.5C1.5 17.9926 2.5074 19 3.75 19h6.9791a6.7595 6.7595 0 0 1-.2291-1.75c0-3.7279 3.0221-6.75 6.75-6.75 1.3876 0 2.6774.4187 3.75 1.1367Zm-.2483 3.0558a.75.75 0 0 1 .0558 1.0592l-4.083 4.5367-2.9546-2.4622a.75.75 0 0 1 .9602-1.1524l1.8454 1.5378 3.117-3.4633a.75.75 0 0 1 1.0592-.0558Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuResourceManifestFilled'
);
